import React, { useContext } from 'react';
import { LangContext } from '../../contexts/langContext';
import { SocialContext } from '../../contexts/socialContext';
import { prepareGates } from '../utilsDesign';
import GateFocused from './GateFocused';
import GateNumber from './GateNumber';
import { Txt } from './Txt';
import { TooltipH } from './TooltipH';
import { Videos } from './Videos';
import { GateAllActivations } from './GateAllActivations';
import { ChannelTypeInfo } from './Channel';



export const GateInfo = (props) => {

  const {
    hexagram,
    number,
    design = {},
    gateId = '',
    title = true,
    desctiption = true,
    videos = false,
    planets = false,
    types = [],
    circuit = '',
    stream = '',
    activated = false,
    showBodygraphHint = false,
  } = { ...props };
  // console.log('props123 = ', props);

  const context = { ...useContext(LangContext), ...useContext(SocialContext) };
  const $ui = context.$ui;
  const $gate = context.$gate;

  const designGates = design ? design['gates'] : [];


  let prsDes;
  const prsD = prepareGates(design.gates, 'des')[gateId]
  const prsP = prepareGates(design.gates, 'prs')[gateId]

  if (prsD && prsP) prsDes = 'prsdes'
  if (prsD && !prsP) prsDes = 'des'
  if (!prsD && prsP) prsDes = 'prs'



  return (<>
    {context.languageReady &&

      <div className="_fv _fgap04">

        {(title || hexagram || number) && <div className="x_edu_channel_title">

          {number && <>
            {showBodygraphHint
              ? <TooltipH
                mobileOff
                title={<GateFocused
                  design={design}
                  gateId={gateId}
                  style={{ width: '12em', height: '10em', borderRadius: '0.4em' }}
                />}
              >
                <span><GateNumber design={design} gateId={gateId} /></span>
              </TooltipH>
              : <GateNumber design={design} gateId={gateId} />}
          </>}

          <span className="x_edu_channel_h1 x_edu_channel_h1--2">
            {hexagram && <span className="x_gate_title_hex">
              {$gate(gateId, 'hexagram')} </span>}
            {title && <><span className="x_edu_channel_of _tnowrap">{$ui('gate_of')}</span>  {$gate(gateId, 'title')}</>}
          </span>

        </div>}

        {desctiption && <div className="x_edu_item_desc">
          <Txt>{$gate(gateId, 'description')}</Txt>
        </div>}

        {videos && <Videos
          title={`${$gate(gateId, 'id')}. ${$gate(gateId, 'title')}`}
          size='sm'
          relType='gates'
          relValue={gateId.toString()} />}


        {activated && <ChannelTypeInfo
          {...props}
        />}


        {planets && <GateAllActivations
          hexagram={false}
          number={false}
          design={design}
          gateId={gateId}
        />}

      </div>




    }

  </>)
}